import api from '../../apiConfig/apiConfig'
import { Get, Post, Put, Delete } from '../base/baseAjax'
let workorderlog = param => {
  // alert(typeof id, id)
  return Get({
    url: api.workorder.getWorkOrderInfo,
    PathParam: param
  })
}

let addRemarks = param => {
  return Post({
    url: api.workorder.addRemarks,
    bodyParam: param
  })
}
export default {
  workorderlog,
  addRemarks
}
